<template>
  <el-dialog :visible.sync="visiable" width="480px">
    <div class="ukey_dialog_banner">
      <el-icon class="el-icon-error ukey_dialog_banner_icon"></el-icon>
      <p class="ukey_dialog_banner_title">
        您已连续输错密码，为保护您的安全，该法人一证通已被锁定。
      </p>
      <p class="ukey_dialog_banner_text">
        如需解锁法人一证通，请进行“解锁”操作
      </p>
      <a
        class="ukey_dialog_banner_link"
        href="https://www.962600.com/help/article/8e8078f76b3f4bdb9ff4fb1219265 9a5"
      >
        https://www.962600.com/help/article/8e8078f76b3f4bdb9ff4fb1219265 9a5
      </a>
    </div>
    <template slot="footer">
      <div class="ukey_dialog_button" @click="visiable = false">好的</div>
    </template>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      visiable: false,
    };
  },
  methods: {
    show() {
      this.visiable = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.ukey {
  &_dialog_banner {
    width: 352px;
    margin: 0 auto;
    position: relative;
    &_icon {
      position: absolute;
      top: 0;
      left: -40px;
      color: #ea4837;
      font-size: 24px;
    }
    &_title {
      font-size: 16px;
      font-family: SourceHanSansCN-Medium, SourceHanSansCN;
      font-weight: 500;
      color: #000000;
      line-height: 24px;
      margin-bottom: 16px;
    }
    &_text {
      font-size: 14px;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-weight: 400;
      color: #6a6c7d;
      line-height: 22px;
    }
    &_link {
      color: #3340ca;
      text-decoration: none;
      cursor: pointer;
    }
  }
}
</style>